function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "28.8"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4944",
  "data-name": "Group 4944",
  transform: "translate(-290.5 -309.345)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_124",
  "data-name": "Rectangle 124",
  d: "M3 3v22.8h34V3H3M0 0h40v28.8H0z",
  transform: "translate(290.5 309.345)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3913",
  "data-name": "Group 3913",
  transform: "translate(291.746 310.589)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M14609.316 9619.959l-5.953 5.955h5.953z",
  transform: "translate(-14573.138 -9600.416)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2703",
  "data-name": "Path 2703",
  d: "M14609.316 9619.959l-5.953 5.955h5.953z",
  transform: "rotate(180 7305.271 4813.229)"
})))));